import {
  adminPharmacyRatingItems,
  adminProfessionalRatingItems,
  getAdminPharmacistRating,
  getAdminPharmacyRating,
  getAdminPharmacyRatingItems,
  getAdminProfessionalRatingItems,
  TypeOfUser,
} from '@pharmaplan/common';
import { useEffect } from 'react';
import { useAppDispatch } from '../useAppDispatch';
import { useAppSelector } from '../useAppSelector';

const { pharmacist, pharmacy } = TypeOfUser;

const useAdminViewRating = (userType: TypeOfUser, id: string) => {
  const dispatch = useAppDispatch();

  const pharmacistRatingData = useAppSelector(adminProfessionalRatingItems);
  const pharmacyRatingData = useAppSelector(adminPharmacyRatingItems);

  const config = {
    [pharmacist]: {
      idProperty: 'professionalRatingItemId',
      itemProperty: 'professionalRatingItems',
      getRatingItems: getAdminProfessionalRatingItems,
      getRating: getAdminPharmacistRating,
      ratingData: pharmacistRatingData,
    },
    [pharmacy]: {
      idProperty: 'pharmacyRatingItemId',
      itemProperty: 'pharmacyRatingItems',
      getRatingItems: getAdminPharmacyRatingItems,
      getRating: getAdminPharmacyRating,
      ratingData: pharmacyRatingData,
    },
  };

  const { idProperty, itemProperty, getRatingItems, getRating, ratingData } = config[userType as keyof typeof config];

  useEffect(() => {
    dispatch(getRatingItems(id));
    dispatch(getRating(id));
  }, []);

  return { idProperty, itemProperty, ratingData };
};

export default useAdminViewRating;
